module.exports = __webpack_public_path__ + "static/media/fastRail.776661e9.jpg";